import hexToRgb from "./hexToRgb";

const setupV2Theme = (themeConfig) => {
    if (themeConfig) {
        const { colors, fonts } = themeConfig;
        const {
            headerColorFirst, // Hader Section Color
            headerColorSecond, // Header Section Color 2
            backgroundColorFirst, // Background Color 1
            textColor, // Text Color
            errorColor, // error-color
            backgroundColorSecond, // Background Color 2
            formColor, //Form color
            representativeBubbleColor, //Representative bubble color
            representativeTextColor, //Representative text color
            customerBubbleColor, //Customer bubble color
            customerTextColor, //Customer text color
            buttonColor, //Button color
            headerTextColor, //Header text color
            formColorText, //Form color text
            chatBotButtonText, //Chatbot button text color
            chatBotButtonColor, //Chatbot button color
        } = colors;

        var themeParameterConfigMap = [];

        themeParameterConfigMap["header-color"] = headerColorFirst;
        themeParameterConfigMap["header-color-second"] = headerColorSecond;
        themeParameterConfigMap["background-color-first"] = backgroundColorFirst;
        themeParameterConfigMap["background-color-second"] = backgroundColorSecond;
        themeParameterConfigMap["primary_"] = headerColorFirst;
        themeParameterConfigMap["primary-text"] = textColor;
        themeParameterConfigMap["secondary-text"] = customerTextColor;
        themeParameterConfigMap["chat-bubble-readonly-text"] = textColor;
        themeParameterConfigMap["chat-bubble-text-bg"] = backgroundColorFirst;
        themeParameterConfigMap["agent-bubble-color"] = representativeBubbleColor;
        themeParameterConfigMap["agent-bubble-text-color"] = representativeTextColor;
        themeParameterConfigMap["customer-bubble-color"] = customerBubbleColor;
        themeParameterConfigMap["customer-text-color"] = customerTextColor;
        themeParameterConfigMap["message-time"] = customerTextColor;
        themeParameterConfigMap["footer-text-color"] = customerTextColor;
        themeParameterConfigMap["footer-bg"] = backgroundColorFirst;
        themeParameterConfigMap["chat-input-bg"] = backgroundColorFirst;
        themeParameterConfigMap["chat-input-ph"] = "#a1a8a8";
        themeParameterConfigMap["chat-input-icon"] = "#A2A8A8";
        themeParameterConfigMap["color-bt"] = "#E4E8ED";
        themeParameterConfigMap["form-input-label"] = formColorText;
        themeParameterConfigMap["form-input-border"] = buttonColor;
        themeParameterConfigMap["form-input-text"] = formColorText;
        themeParameterConfigMap["lang-list-primary"] = backgroundColorFirst;
        themeParameterConfigMap["button-color"] = buttonColor;
        themeParameterConfigMap["header-text-color"] = headerTextColor;
        themeParameterConfigMap["form-color-text"] = formColorText;
        themeParameterConfigMap["error-color"] = errorColor;
        themeParameterConfigMap["lang-list-secondary"] = hexToRgb(backgroundColorFirst, 5);
        themeParameterConfigMap["translate-received"] = hexToRgb(backgroundColorFirst, 22);
        themeParameterConfigMap["scrollbar-color"] = hexToRgb(backgroundColorFirst, 22);
        themeParameterConfigMap["scrollbar-color"] = headerColorFirst + "75";
        themeParameterConfigMap["main-text-color"] = "white";
        themeParameterConfigMap["chatbot-button-text-color"] = chatBotButtonText;
        themeParameterConfigMap["chatbot-button-color"] = chatBotButtonColor;
        if (fonts && fonts.fontCustom) {
            themeParameterConfigMap["theme-font"] = fonts.fontCustom;
        } else {
            themeParameterConfigMap["theme-font"] = "Poppins";
        }
        setCSSParameters(themeParameterConfigMap);
    }
};

const setCSSParameters = (parameterConfigMap) => {
    const r = document.querySelector(":root");
    Object.keys(parameterConfigMap).forEach((key) => {
        r.style.setProperty(`--${key}`, parameterConfigMap[key]);
    });
};

export default setupV2Theme;



// WEBPACK FOOTER //
// ./src/utils/theme/setupV2Theme.js